import Header from '../components/HeaderLogin'
import LogIn from "../components/LoginComp";
import "./SignUp.css";

const Login = () => {
  return (
    <div className="mainFrame" style = {{minHeight: '100vh'}}>
      <Header/>
      <LogIn/>
    </div>
  );
};

export default Login;